<template>
    <div class="bash-wrap customer-case-wrap">
            <div class="bash-box">
                <p class="h1-title">{{ indata.FirstTitle }}</p>
                <p class="h2-title">{{ indata.subTitle }}</p>
                <i class="customer-case-bg" :style="'background:url(' + indata.showImage + ') no-repeat 50% 50%;'"></i>
                    
            </div>
        </div>
</template>
        
<script>
export default {
  name: "Templates3",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
